import { render, staticRenderFns } from "./NewsInfoModal.vue?vue&type=template&id=4179ed81&scoped=true"
import script from "./NewsInfoModal.vue?vue&type=script&lang=js"
export * from "./NewsInfoModal.vue?vue&type=script&lang=js"
import style0 from "./NewsInfoModal.vue?vue&type=style&index=0&id=4179ed81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179ed81",
  null
  
)

export default component.exports